import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCampaign } from 'state'
import { getCampaign, CampaignState, updateRegistrationMaxSlots } from 'state/campaigns'
import { NewTrans, useNewTranslation } from 'hooks/index'
import FormPopUp from './FormPopUp'
import Modal from 'particles/Modal'
import Text from 'particles/Text'

interface UpdateRegistrationMaxSlotsProps {
    campaign: CampaignState
}
const UpdateRegistrationMaxSlots: React.FC<UpdateRegistrationMaxSlotsProps> = ({ campaign }) => {
    const [showIncreaseConfirmContent, setShowIncreaseConfirmContent] = useState({ show: false, slots_value: null })
    const [newT] = useNewTranslation()
    const { uuid } = campaign
    const campaignContent = useSelector(selectCampaign(uuid))
    const dispatch = useDispatch()

    const getCampaignData = () => {
        dispatch(getCampaign({ uuid }))
    }

    const onSubmitEvent = (values: any, lastEditSlots: number) => {
        if (values.registration_max_slots > lastEditSlots) {
            setShowIncreaseConfirmContent({ show: true, slots_value: values.registration_max_slots })
        } else {
            dispatch(
                updateRegistrationMaxSlots({
                    max_slots: Number(values.registration_max_slots),
                    uuid: campaign.uuid,
                }),
            )
        }
    }
    const recallIncrease = () => {
        setShowIncreaseConfirmContent({ ...showIncreaseConfirmContent, show: false })
    }
    const onSubmitIncreaseSlots = () => {
        const { slots_value } = showIncreaseConfirmContent
        setShowIncreaseConfirmContent({ ...showIncreaseConfirmContent, show: false })
        dispatch(
            updateRegistrationMaxSlots({
                max_slots: Number(slots_value),
                uuid: campaign.uuid,
            }),
        )
    }
    if (showIncreaseConfirmContent.show)
        return (
            <>
                {showIncreaseConfirmContent.show && (
                    <Modal
                        title={newT('modalWindow.confirmationMessage.changeRegistrationSlotTitle')}
                        size="s"
                        isClosable={false}
                        primaryButtonProps={{
                            label: newT('button.confirm'),
                        }}
                        secondaryButtonProps={{
                            label: newT('button.close'),
                        }}
                        onConfirm={onSubmitIncreaseSlots}
                        onClose={recallIncrease}
                    >
                        <NewTrans i18nKey="modalWindow.confirmationMessage.changeRegistrationSlotSubtitle">
                            <Text scale="bodyM400">
                                When the max slot is increased, we will automatically approve Partiposter(s) from the
                                waitlist
                            </Text>
                        </NewTrans>
                    </Modal>
                )}
            </>
        )
    return <FormPopUp campaignContent={campaignContent} onOpen={getCampaignData} onSubmit={onSubmitEvent} />
}

export default UpdateRegistrationMaxSlots
